module.exports = __webpack_public_path__ + "static/media/planta2.33e41fdb.jpg";